import Vue from 'vue';
import Vuex from 'vuex';
import * as actions from './actions';
import * as getters from './getters';
import {mutations} from './mutations';

Vue.use(Vuex);

// 应用初始化
const state = {
    menu: [], // 菜单
    homeTabs: [], // 打开总的tab
    homeCurrentTab: '0', // 当前tab
    tabIndex: 0, // 打开tab的数量
    currentTab: {},
    socketData: {}, // websocket返回参数
    permission: [], // 权限管理
    orderManageData: '' // 车辆管理传给订单管理的数据
};

// 创建 store 实例
export default new Vuex.Store({
    actions,
    getters,
    state,
    mutations
});


// WEBPACK FOOTER //
// ./src/store/store.js